import {NgClass} from '@angular/common';
import {booleanAttribute, Component, ElementRef, EventEmitter, Input, Output, ViewChild} from '@angular/core';

import {SimpleLibelleComponent} from '../simple-libelle/simple-libelle.component';
import {FonteIconeComponent} from '../fonte-icone/fonte-icone.component';

//Composant fiche générique
@Component (
{
  selector: 'val-fiche-generique',
  imports:
  [
    NgClass,
    SimpleLibelleComponent,
    FonteIconeComponent
  ],
  templateUrl: './fiche-generique.component.html',
  styleUrl: './fiche-generique.component.scss'
})
export class FicheGeneriqueComponent<T>
{
  //Création
  constructor ()
  {
    this.fermerVisible = true;
    this.fermerClick = new EventEmitter<void> ();
  }

  //Fiche générique
  @ViewChild ("ficheGenerique")
  public ficheGenerique!: ElementRef;

  //Titre de la fiche
  @Input ()
  public titre!: string;

  //Indique si le bouton fermer est visible
  @Input ({transform: booleanAttribute})
  public fermerVisible: boolean;

  //Evénement fermer
  @Output ()
  public fermerClick: EventEmitter<void>;

  //Fonction de retour
  public fonctionRetour!: (retourFiche: T) => void;

  //Ouvre la fiche
  //  Retourne
  //    Données de retour
  public async Ouvrir () : Promise<T>
  {
    let operation: Promise<T>;

    this.ficheGenerique.nativeElement.showModal ();

    operation = new Promise<T> ((fonctionRetour) =>
    {
      this.fonctionRetour = fonctionRetour;
    });

    return operation;
  }

  //Ferme la fiche
  public Fermer () : void
  {
    this.ficheGenerique.nativeElement.close ();
  }

  //Indique si la fiche est ouverte
  //  Retourne
  //    Vrai si la fiche est ouverte
  public Ouverte () : boolean
  {
    return this.ficheGenerique.nativeElement.open;
  }

  //Envoie l'évènement fermer
  public EnvoyerFermer () : void
  {
    this.fermerClick.emit ();
  }
}
